module.exports = __webpack_public_path__ + "img/Priest-bloodelf-m-70.9f7583e5.gif";